module.exports = __webpack_public_path__ + "assets/ccedb7e29b4f5632e35f310823f68d39.png";